/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Kpi
 */
export interface Kpi {
    /**
     * 
     * @type {string}
     * @memberof Kpi
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Kpi
     */
    attribute: string;
    /**
     * 
     * @type {number}
     * @memberof Kpi
     */
    weight: number;
    /**
     * 
     * @type {boolean}
     * @memberof Kpi
     */
    directionUp: boolean;
    /**
     * 
     * @type {number}
     * @memberof Kpi
     */
    position: number;
}

/**
 * Check if a given object implements the Kpi interface.
 */
export function instanceOfKpi(value: object): value is Kpi {
    if (!('attribute' in value) || value['attribute'] === undefined) return false;
    if (!('weight' in value) || value['weight'] === undefined) return false;
    if (!('directionUp' in value) || value['directionUp'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    return true;
}

export function KpiFromJSON(json: any): Kpi {
    return KpiFromJSONTyped(json, false);
}

export function KpiFromJSONTyped(json: any, ignoreDiscriminator: boolean): Kpi {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'attribute': json['attribute'],
        'weight': json['weight'],
        'directionUp': json['directionUp'],
        'position': json['position'],
    };
}

export function KpiToJSON(json: any): Kpi {
    return KpiToJSONTyped(json, false);
}

export function KpiToJSONTyped(value?: Kpi | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'attribute': value['attribute'],
        'weight': value['weight'],
        'directionUp': value['directionUp'],
        'position': value['position'],
    };
}

